import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Title = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-top: 32px;
`;

export const WarningNote = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #5b5675;
    margin-top: 6px;
`;

export const DocumentUploadWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 26px;
`;

export const SubmitButtonWrapper = styled.div`
    margin-top: 40px;
`;

export const CalendarInputWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 10px;
    border: 1px solid #e0e0e8;
    border-radius: 8px;
`;

export const InputLabel = styled.label`
    font-size: 14px;
    line-height: ${(props) => props.theme.typography.lineHeights.C1};
    position: absolute;
    left: 28px;
    top: 52%;
    transform: translateY(-50%);
    color: ${(props) => props.colors.neutral.n400};
    background-color: ${(props) => props.colors.primary.n0};
    transition: all 0.15s ease-out 0s;
    pointer-events: none;
    font-family: ${(props) => props.theme.typography.fonts.family.family};
    &.shiftRight {
        left: ${(props) => props.theme.spacing[9]};
    }
    padding: 0 ${(props) => props.theme.spacing[1]};
`;

export const LabelText = styled.div`
    display: flex;
    flex: 4;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #5b5675;
`;

export const CalendarIcon = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
`;

export const PurchaseDateWrapper = styled(DocumentUploadWrapper)`
    position: relative;
    &::after {
        content: ${(props) => `'${props.content}'`};
        position: absolute;
        pointer-events: none;
        bottom: 0;
        left: 10px;
        top: -48px;
        margin: auto;
        background: white;
        padding: 2px 6px;
        height: max-content;
        color: #5b5675;
        font-size: 14px;
    }
`;
